import { Box } from '@mui/material';
import { Spinner } from '../../../../../../../components/design/Spinner';

export const DialogLoadingFallback = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "220px",
      width: "100%"
    }}>
    <Spinner centerPage={false} />
  </Box>
);

